import { useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV, WHATSAPP_URL } from "../content";
import { scrollToId } from "../lib/lenis";
import { WhatsAppIcon } from "../lib/icons";

const LOGO = "/assets/logo-horizontal.webp";

export const Header = () => {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 bg-tinta/95 backdrop-blur-md border-b border-inkline"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 md:h-[72px] flex items-center justify-between gap-4">
        <button
          data-testid="header-logo"
          onClick={() => go("topo")}
          className="shrink-0"
          aria-label="DealFlow Lab — voltar ao topo"
        >
          <img src={LOGO} alt="DealFlow Lab" className="h-9 md:h-10 w-auto" />
        </button>

        <nav className="hidden lg:flex items-center gap-7" aria-label="Navegação principal">
          {NAV.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-link-${item.id}`}
              onClick={() => go(item.id)}
              className="font-sora text-[13px] font-semibold tracking-[-0.02em] text-creme/80 hover:text-lima transition-colors duration-150"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2.5">
          <a
            data-testid="header-whatsapp-link"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Falar no WhatsApp"
            className="w-10 h-10 flex items-center justify-center border border-inkline text-lima hover:border-lima transition-colors duration-150"
          >
            <WhatsAppIcon className="w-[18px] h-[18px]" />
          </a>
          <button
            data-testid="header-cta-button"
            onClick={() => go("contato")}
            className="hidden sm:inline-flex bg-lima text-tinta font-sora font-bold text-[13px] tracking-[-0.02em] px-5 h-10 items-center hover:bg-[#d4ff66] transition-colors duration-150"
          >
            Agendar diagnóstico
          </button>
          <button
            data-testid="mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="lg:hidden w-10 h-10 flex items-center justify-center border border-inkline text-creme"
            aria-label={open ? "Fechar menu" : "Abrir menu"}
            aria-expanded={open}
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          data-testid="mobile-menu"
          className="lg:hidden bg-tinta border-t border-inkline px-5 py-4 flex flex-col gap-1"
          aria-label="Navegação mobile"
        >
          {NAV.map((item) => (
            <button
              key={item.id}
              data-testid={`mobile-nav-link-${item.id}`}
              onClick={() => go(item.id)}
              className="text-left font-sora font-semibold text-creme py-3 border-b border-inkline last:border-0"
            >
              {item.label}
            </button>
          ))}
          <button
            data-testid="mobile-cta-button"
            onClick={() => go("contato")}
            className="mt-3 bg-lima text-tinta font-sora font-bold text-sm px-5 h-11"
          >
            Agendar diagnóstico
          </button>
        </nav>
      )}
    </header>
  );
};
